query CourseContentQuery($handle: String!, $language: String!) {
  learnWorldsCourse(handle: $handle, language: $language) {
    created
    updated
    language
    handle
    courseID
    title
    description
    authorName
    authorImage
    courseImage

    sections {
      created
      updated
      sectionId
      sectionTitle
      sectionDescription
      sectionAccess
      unitSummary {
        key
        count
      }
    }
  }
}
